const CHANGE_OF_AIRPORT = 'CHANGE_OF_AIRPORT';
const OVERNIGHT_STAY = 'OVERNIGHT_STAY';
const SELF_TRANSFER = 'SELF_TRANSFER';
const STOP = 'STOP';
const TRANSFER_TO_AIRPORT = 'TRANSFER_TO_AIRPORT';
const TRANSFER_TO_BUS = 'TRANSFER_TO_BUS';
const TRANSFER_TO_TRAIN = 'TRANSFER_TO_TRAIN';

export {
  CHANGE_OF_AIRPORT,
  OVERNIGHT_STAY,
  SELF_TRANSFER,
  STOP,
  TRANSFER_TO_AIRPORT,
  TRANSFER_TO_BUS,
  TRANSFER_TO_TRAIN,
};
